import image1 from "../../Assets/features/feature3.png";
import image2 from "../../Assets/features/feature2.png";
import image3 from "../../Assets/features/feature1.png";
import image4 from "../../Assets/features/feature4.png";
import image5 from "../../Assets/features/feature5.png";
import svg from "../../Assets/Background/svg.png";
import { CgArrowLongRight } from "react-icons/cg";

import { Feature, FeatureTwo } from "../Feature/Feature";
import { Link } from "react-router-dom";

const Features = () => {
  const features = [
    {
      name: "Accept payments in Mobile Money and Crypto instantly",
      title:
        "Offer quick convenient payments to all your customers from every part of the world. Accept Mobile payments (Mpesa, Tigo, MTN) and over 70 Crypto currencies to choose from.",
      image: image1,
      cta: "View payment options",
    },
    {
      name: "Set up recurring payments once and forget",
      title:
        "Automate your recurring payments with Lipana. Offer subscriptions in your business or set up recurring invoices once , and wait to get paid regularly.",
      image: image2,
      cta: "Explore subscriptions",
    },
  ];

  const featuresTwo = [
    {
      name: "Fast payment APIs and Integrations",
      title:
        "Access our fast APIs, clear documentation and fast integration designed to suit your particular business.",
      image: image3,
      cta: "View documentation",
    },
    {
      name: "Quick and reliable settlements",
      title:
        "Receive your online payments directly to your bank account or mobile money wallets within 1-2 business days without delay.",
      image: image4,
      cta: "Explore payouts options",
    },
    {
      name: "Go 100% contactless in your business",
      title:
        "Get a QR Code to start accepting contactless payments directly from your business premises, quickly and securely.",
      image: image5,
      cta: "Explore Qr code payments",
    },
  ];

  return (
    <section className="px-6 xl:px-0 mt-32 p-20 text-blackColor">
      <div className="mx-auto max-w-7xl h-full">
        <div className="space-y-3">
          <h2 className="text-center text-2xl font-semibold md:text-4xl md:leading-[3.4rem]">
            Features to help you grow your business online fast.
          </h2>
        </div>

        <Link
          to="/"
          className="text-white background2 duration-500 flex flex-col justify-end p-4 space-y-5 rounded-[20px] h-[65vh] mt-10 md:p-8 md:rounded-[40px]"
        >
          <h2 className="text-2xl font-semibold duration-300 md:text-4xl md:leading-[3.2rem]">
            Get paid online from  <br /> anywhere, anytime
          </h2>
          <p className="md:text-lg lg:w-1/2">
            Create a payment link in seconds and get paid easily for
            subscriptions, donations and one time payments from clients.
          </p>
          <Link
            to="https://app.lipana.co.ke/signup"
            className="text-brandColor font-semibold flex flex-row items-center gap-1 hover:gap-3 hover:underline duration-500 cursor-pointer"
          >
            Learn more
            <CgArrowLongRight className="text-2xl" />
          </Link>
        </Link>

        <div className="mt-10 md:mt-32">
          <Feature data={features} height="700px" />
        </div>

        <Link
          to="/"
          className="radial relative duration-500 flex flex-row space-y-5 rounded-[20px] h-[65vh] mt-16 md:p-8 md:rounded-[40px]"
        >
          <div className="flex flex-col justify-end absolute w-full bottom-4 left-0 p-4  lg:w-1/2 lg:relative">
            <h2 className="text-2xl font-semibold text-white duration-300 md:text-4xl">
              Easy payouts to diferrent countries
            </h2>
            <p className="text-white">
              Make payments to suppliers, contractors, casual workers and
              employees instantly and directly to their bank accounts ro mobile
              money wallets
            </p>
            <Link
              to="https://app.lipana.co.ke/signup"
              className="text-brandColor font-semibold flex flex-row items-center gap-1 hover:gap-3 hover:underline duration-500 cursor-pointer"
            >
              Explore payouts
              <CgArrowLongRight className="text-2xl" />
            </Link>
          </div>
          <div className="w-full object-cover md:w-3/4 h-full">
            <img src={svg} alt="" className="w-full h-96 object-contain md:h-full" />
          </div>
        </Link>

        <div className="mt-10 md:mt-32">
          <FeatureTwo data={featuresTwo} height="700px" />
        </div>
      </div>
    </section>
  );
};

export default Features;
